import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'www';

export const wwwI18nManifest: SliceI18nManifest = {
  owner: 'modules/www',
  namespaces: [NS],
  resources: {
    cs: { [NS]: cs },
    en: { [NS]: en },
  },
};
